import { Dialog as VoidDialog } from "@void-orbit/ui";

export interface DialogProps {
  children: JSX.Element;
  open: boolean;
  onClose?: () => void;
  ariaLabel?: string;
};

export const Dialog = ({ children, open, onClose, ariaLabel = "Janela de diálogo" }: DialogProps ) => (
  <VoidDialog open={ open } onClose={ onClose } aria-label={ ariaLabel }>{ children }</VoidDialog>
);
